export interface Chapter {
  id: number;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  rating: number;
  views: number;
  status: 'ongoing' | 'completed';
  updateDate: string;
  chapters: Chapter[];
  featured: boolean;
  latest: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '星辰之恋',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20romantic%20couple%20under%20starry%20night%20sky%2C%20soft%20pastel%20pink%20and%20purple%20tones%2C%20gentle%20embrace%2C%20whimsical%20atmosphere%2C%20clean%20minimal%20illustration%20style%2C%20simple%20solid%20background%20with%20subtle%20stars%2C%20flat%20color%20palette&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一个关于天文系学生与神秘转校生之间浪漫故事的韩国漫画。当热爱星星的少女遇见了仿佛来自另一个世界的少年，两人的命运从此交织在一起。作品以细腻的笔触描绘了青春、梦想与初恋的美好，画风清新唯美，深受读者喜爱。',
    categories: ['love', 'school'],
    rating: 4.8,
    views: 12500000,
    status: 'ongoing',
    updateDate: '2026-08-03',
    featured: true,
    latest: true,
    chapters: [
      { id: 101, title: '第120话 - 星空下的约定', number: 120, date: '2026-08-03' },
      { id: 102, title: '第119话 - 靠近的心', number: 119, date: '2026-07-27' },
      { id: 103, title: '第118话 - 意外的告白', number: 118, date: '2026-07-20' },
      { id: 104, title: '第117话 - 夏日祭典', number: 117, date: '2026-07-13' },
      { id: 105, title: '第116话 - 天台上的秘密', number: 116, date: '2026-07-06' },
      { id: 106, title: '第115话 - 交换日记', number: 115, date: '2026-06-29' },
      { id: 107, title: '第114话 - 第一次约会', number: 114, date: '2026-06-22' },
      { id: 108, title: '第113话 - 误会与和解', number: 113, date: '2026-06-15' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法',
    author: '李敏浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20action%20fantasy%20warrior%20holding%20glowing%20sword%2C%20dramatic%20dynamic%20pose%2C%20dark%20atmospheric%20background%20with%20magical%20sparks%2C%20warm%20earth%20tone%20color%20palette%2C%20stylized%20illustration%2C%20simple%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个魔法与剑术并存的世界中，平凡的少年意外获得了传说中的圣剑，从此踏上了拯救王国的冒险之旅。这部韩国漫画融合了精彩的战斗场面与引人入胜的剧情发展，世界观宏大，角色塑造丰满。',
    categories: ['action', 'fantasy'],
    rating: 4.9,
    views: 18300000,
    status: 'ongoing',
    updateDate: '2026-08-04',
    featured: true,
    latest: true,
    chapters: [
      { id: 201, title: '第205话 - 最终决战开幕', number: 205, date: '2026-08-04' },
      { id: 202, title: '第204话 - 援军到来', number: 204, date: '2026-07-28' },
      { id: 203, title: '第203话 - 龙之谷', number: 203, date: '2026-07-21' },
      { id: 204, title: '第202话 - 圣剑觉醒', number: 202, date: '2026-07-14' },
      { id: 205, title: '第201话 - 最后的试炼', number: 201, date: '2026-07-07' },
    ],
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20elegant%20woman%20in%20chic%20outfit%2C%20mysterious%20atmosphere%2C%20warm%20rosy%20tone%2C%20modern%20urban%20night%20setting%2C%20romantic%20thriller%20vibe%2C%20clean%20flat%20illustration%20style%2C%20simple%20solid%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '职场精英女主角在相亲中遇到了一个看似完美的男人，然而这段关系背后却隐藏着不为人知的秘密。这是一部将浪漫与悬疑完美结合的韩国漫画，剧情反转不断，让人欲罢不能。',
    categories: ['love', 'thriller'],
    rating: 4.7,
    views: 9800000,
    status: 'completed',
    updateDate: '2026-07-15',
    featured: false,
    latest: false,
    chapters: [
      { id: 301, title: '第98话 - 真相大白（最终话）', number: 98, date: '2026-07-15' },
      { id: 302, title: '第97话 - 最后的对峙', number: 97, date: '2026-07-08' },
      { id: 303, title: '第96话 - 隐藏的证据', number: 96, date: '2026-07-01' },
    ],
  },
  {
    id: 4,
    title: '异世界餐厅',
    author: '崔恩瑞',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20cozy%20restaurant%20interior%20with%20fantasy%20creatures%20dining%2C%20warm%20golden%20lighting%2C%20whimsical%20comedy%20style%2C%20delicious%20food%20dishes%2C%20friendly%20chef%20character%2C%20clean%20flat%20illustration%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '一位韩国厨师意外穿越到奇幻异世界，凭借精湛的厨艺在异世界开起了餐厅。各种奇幻生物被美食吸引而来，发生了一系列温馨有趣的故事。这部韩国漫画轻松治愈，美食画面精美诱人。',
    categories: ['fantasy', 'comedy'],
    rating: 4.6,
    views: 7600000,
    status: 'ongoing',
    updateDate: '2026-08-02',
    featured: false,
    latest: true,
    chapters: [
      { id: 401, title: '第87话 - 龙族的盛宴', number: 87, date: '2026-08-02' },
      { id: 402, title: '第86话 - 精灵的甜点', number: 86, date: '2026-07-26' },
      { id: 403, title: '第85话 - 兽人族的烤肉', number: 85, date: '2026-07-19' },
    ],
  },
  {
    id: 5,
    title: '校园怪谈',
    author: '郑多彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20school%20hallway%20at%20night%2C%20mysterious%20shadow%20figure%2C%20eerie%20atmosphere%2C%20horror%20thriller%20vibe%2C%20cool%20dark%20gray%20tones%2C%20suspenseful%20composition%2C%20flat%20illustration%20style%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '在一所历史悠久的学校中，流传着七个不为人知的恐怖传说。一群好奇心旺盛的学生决定逐一揭开这些传说背后的真相，却发现自己正一步步陷入无法逃脱的恐怖之中。这部韩国恐怖漫画氛围营造出色，悬疑感极强。',
    categories: ['horror', 'thriller', 'school'],
    rating: 4.5,
    views: 8900000,
    status: 'completed',
    updateDate: '2026-06-30',
    featured: false,
    latest: false,
    chapters: [
      { id: 501, title: '第66话 - 第七个传说（最终话）', number: 66, date: '2026-06-30' },
      { id: 502, title: '第65话 - 最后的幸存者', number: 65, date: '2026-06-23' },
      { id: 503, title: '第64话 - 体育馆的哭声', number: 64, date: '2026-06-16' },
    ],
  },
  {
    id: 6,
    title: '花开时节',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20two%20young%20men%20in%20cherry%20blossom%20garden%2C%20gentle%20romantic%20atmosphere%2C%20soft%20pink%20and%20cream%20tones%2C%20tender%20emotional%20moment%2C%20beautiful%20spring%20scene%2C%20clean%20delicate%20illustration%20style%2C%20simple%20pastel%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '青梅竹马的两人从小一起长大，感情在不知不觉中超越了友情的界限。这部韩国耽美漫画以春日为背景，用细腻温柔的笔触描绘了两人之间的情感变化，画面唯美，故事感人至深。',
    categories: ['bl', 'drama'],
    rating: 4.8,
    views: 11200000,
    status: 'ongoing',
    updateDate: '2026-08-04',
    featured: true,
    latest: true,
    chapters: [
      { id: 601, title: '第78话 - 樱花雨', number: 78, date: '2026-08-04' },
      { id: 602, title: '第77话 - 无法说出口的话', number: 77, date: '2026-07-28' },
      { id: 603, title: '第76话 - 雨天的回忆', number: 76, date: '2026-07-21' },
    ],
  },
  {
    id: 7,
    title: '都市猎人',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mysterious%20man%20in%20black%20coat%20on%20rooftop%2C%20cityscape%20night%20background%2C%20action%20thriller%20vibe%2C%20cool%20urban%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20stylized%20flat%20illustration%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '白天是普通上班族，夜晚则化身打击犯罪的神秘猎人。主角的双重身份让他在正义与复仇之间徘徊，每一次行动都充满危险与挑战。这部韩国动作漫画节奏紧凑，打斗场面精彩纷呈。',
    categories: ['action', 'thriller'],
    rating: 4.7,
    views: 14500000,
    status: 'ongoing',
    updateDate: '2026-08-03',
    featured: true,
    latest: false,
    chapters: [
      { id: 701, title: '第156话 - 地下拳场', number: 156, date: '2026-08-03' },
      { id: 702, title: '第155话 - 追踪', number: 155, date: '2026-07-27' },
      { id: 703, title: '第154话 - 线人', number: 154, date: '2026-07-20' },
      { id: 704, title: '第153话 - 码头交易', number: 153, date: '2026-07-13' },
    ],
  },
  {
    id: 8,
    title: '千年之约',
    author: '尹智敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20fantasy%20couple%20in%20traditional%20Korean%20hanbok%2C%20ancient%20palace%20background%2C%20mystical%20atmosphere%2C%20warm%20golden%20and%20red%20tones%2C%20romantic%20drama%20vibe%2C%20elegant%20flat%20illustration%20style%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '一位现代女孩在古墓中意外唤醒了沉睡千年的古代王子，两人跨越时空的相遇引发了一段凄美动人的爱情故事。这部韩国奇幻剧情漫画融合了历史元素与现代情感，画面华丽精美。',
    categories: ['fantasy', 'drama', 'love'],
    rating: 4.6,
    views: 10200000,
    status: 'completed',
    updateDate: '2026-05-20',
    featured: false,
    latest: false,
    chapters: [
      { id: 801, title: '第112话 - 千年之约（最终话）', number: 112, date: '2026-05-20' },
      { id: 802, title: '第111话 - 命运的抉择', number: 111, date: '2026-05-13' },
      { id: 803, title: '第110话 - 回到过去', number: 110, date: '2026-05-06' },
    ],
  },
  {
    id: 9,
    title: '搞笑一家人',
    author: '金智媛',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20funny%20family%20portrait%20with%20exaggerated%20expressions%2C%20colorful%20bright%20comedy%20style%2C%20chaotic%20household%20scene%2C%20warm%20vibrant%20colors%2C%20cartoonish%20charming%20illustration%2C%20simple%20clean%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '一个四口之家的日常生活充满了意想不到的笑料。爸爸的迷糊、妈妈的强势、姐姐的中二病和弟弟的调皮，组成了这部让人捧腹大笑的韩国喜剧漫画，温暖又治愈。',
    categories: ['comedy', 'drama'],
    rating: 4.4,
    views: 6700000,
    status: 'ongoing',
    updateDate: '2026-08-02',
    featured: false,
    latest: true,
    chapters: [
      { id: 901, title: '第198话 - 家族旅行大作战', number: 198, date: '2026-08-02' },
      { id: 902, title: '第197话 - 妈妈的秘密菜谱', number: 197, date: '2026-07-26' },
      { id: 903, title: '第196话 - 姐姐的联谊', number: 196, date: '2026-07-19' },
    ],
  },
  {
    id: 10,
    title: '深渊之光',
    author: '朴叙俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20warrior%20descending%20into%20abyss%2C%20glowing%20light%20from%20below%2C%20epic%20dramatic%20atmosphere%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20mysterious%20fantasy%20vibe%2C%20flat%20illustration%20style%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '在世界最深处的地下城最底层，存在着一个从未有人到达过的领域。一位被放逐的冒险者决心探索深渊的秘密，却在那里发现了改变整个世界的真相。这部韩国奇幻漫画世界观宏大，剧情悬疑层层递进。',
    categories: ['fantasy', 'action'],
    rating: 4.9,
    views: 15600000,
    status: 'ongoing',
    updateDate: '2026-08-04',
    featured: true,
    latest: true,
    chapters: [
      { id: 1001, title: '第89话 - 深渊之底', number: 89, date: '2026-08-04' },
      { id: 1002, title: '第88话 - 第七层的守护者', number: 88, date: '2026-07-28' },
      { id: 1003, title: '第87话 - 暗黑精灵的试炼', number: 87, date: '2026-07-21' },
      { id: 1004, title: '第86话 - 远古遗迹', number: 86, date: '2026-07-14' },
      { id: 1005, title: '第85话 - 同伴的背叛', number: 85, date: '2026-07-07' },
    ],
  },
  {
    id: 11,
    title: '青春进行曲',
    author: '李多海',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20group%20of%20high%20school%20friends%20in%20uniform%2C%20bright%20sunny%20day%2C%20cheerful%20youthful%20vibes%2C%20warm%20golden%20sunlight%2C%20school%20rooftop%20scene%2C%20clean%20flat%20illustration%20style%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '五个性格各异的高中生组成了校园里的"万事屋"社团，帮助同学解决各种烦恼。在这个过程中，他们也各自经历着成长、友情和初恋。这部韩国校园漫画青春洋溢，充满了温暖的正能量。',
    categories: ['school', 'comedy'],
    rating: 4.5,
    views: 8100000,
    status: 'ongoing',
    updateDate: '2026-08-01',
    featured: false,
    latest: true,
    chapters: [
      { id: 1101, title: '第134话 - 文化祭的准备', number: 134, date: '2026-08-01' },
      { id: 1102, title: '第133话 - 学生会选举', number: 133, date: '2026-07-25' },
      { id: 1103, title: '第132话 - 期末考试', number: 132, date: '2026-07-18' },
    ],
  },
  {
    id: 12,
    title: '暗夜追踪者',
    author: '宋康锡',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20detective%20in%20trench%20coat%20under%20streetlamp%2C%20rainy%20night%20alley%2C%20noir%20mystery%20atmosphere%2C%20cool%20blue%20gray%20tones%2C%20suspenseful%20thriller%20vibe%2C%20flat%20illustration%20style%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '一位退休刑警因一起离奇的连环案件重返调查前线。随着调查深入，他发现所有线索都指向一个已经"死亡"了十年的人。这部韩国悬疑漫画案情错综复杂，推理过程环环相扣。',
    categories: ['thriller', 'drama'],
    rating: 4.6,
    views: 9300000,
    status: 'completed',
    updateDate: '2026-06-10',
    featured: false,
    latest: false,
    chapters: [
      { id: 1201, title: '第82话 - 真相（最终话）', number: 82, date: '2026-06-10' },
      { id: 1202, title: '第81话 - 凶手的自白', number: 81, date: '2026-06-03' },
      { id: 1203, title: '第80话 - 最后的证据', number: 80, date: '2026-05-27' },
    ],
  },
];

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categories.includes(slug));
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((c) => c.featured);
};

export const getLatestUpdates = (): Comic[] => {
  return comics.filter((c) => c.latest);
};